
import { gql } from '@apollo/client';

export const GET_BILL_RECEIPTS_BY_BILL_ID = gql`
  query GetBillReceiptsByBillId($billId: ID!) {
    getBillReceiptsByBillId(billId: $billId) {
      id
      billId
      receiptNo
      externalSerialNo
      currency
      receiptDate
      receivedAt
      amount
      status
      operatorName
      revokeReason
      revokedAt
      revokeOperatorId
      createdAt
      updatedAt
    }
  }
`;

export const GET_BILL_RECEIPT_BY_ID = gql`
  query GetBillReceiptById($id: ID!) {
    getBillReceiptById(id: $id) {
      id
      billId
      receiptNo
      externalSerialNo
      currency
      receiptDate
      receivedAt
      amount
      status
      operatorName
      revokeReason
      revokedAt
      revokeOperatorId
      createdAt
      updatedAt
    }
  }
`;
